import {
  PROCESSING_ORDER_STATUS,
  PAYMENT_WAITING_ORDER_STATUS,
  IN_PRODUCTION_ORDER_STATUS,
  ON_HOLD_ORDER_STATUS,
  COMPLETED_ORDER_STATUS,
  PACKAGING_ORDER_STATUS,
  SHIPPING_ORDER_STATUS,
  ON_WAY_ORDER_STATUS,
} from '@/constants/order_statuses.js'
import {
  PROCESSING_INVOICE_STATUS,
  PAID_INVOICE_STATUS,
} from '@/constants/invoice_statuses.js'

// USA
export const locale = {
  GENERAL: {
    BACK_TO_TOP: 'Вернуться наверх',
    IMPORTANT: 'Важно',
    SELECT: 'Выбрать',
    PREVIOUS: 'Предыдущий',
    NEXT: 'Следующий',
    DELETE: 'Удалить',
    OK: 'Ок',
    ATTENTION: 'Внимание!',
    FAQ: 'Часто задаваемые вопросы',
    BACK_HOME: 'ВЕРНУТЬСЯ НА ГЛАВНУЮ',
    REPLAY: 'Ответить',
    ACCEPT_ALL: 'Принять все',
    CLOSE: 'Закрыть',
    LEARN_MORE: 'Узнать больше',
    MESSAGE_SEND: 'Сообщение успешно отправлено',
    SEND: 'Отправить',
    SEND_US_EMAIL: 'Отправьте нам e-mail',
    SIZE: 'Размер',
    REPEAT: 'Повторить'
  },
  STORE: {
    SEARCH_TITLE: 'Начните вводить текст, чтобы увидеть искомые товары.',
    WELCOME: 'Добро пожаловать в TUMAR',
    GEOLOCATION:
      'Мы используем геолокацию для отображения <br> правильных товаров, цен и расчета доставки',
    ENABLE_LOCATION:
      'Пожалуйста, включите определение местоположения для продолжения',
    GO_STORE: 'Перейти в магазин',
    IMPORTANT_GEOLOCATION_WARNING:
      'Нам очень важно знать ваше местоположение, чтобы предоставить вам правильные товары и цены. Вы уверены, что хотите продолжить без геолокации?',
    NO_CONTENT: 'На этой странице нет содержимого',
    WORKSHOPS: 'МАСТЕРСКИЕ',
    ADD_TO_CART: 'ДОБАВИТЬ В КОРЗИНУ',
    SALE: 'Скидка',
  },
  NOT_FOUND: {
    PAGE_NOT_FOUND: 'Упс, страница не найдена',
    LINK: 'Ссылка может быть недоступна для вас',
    REMOVED: 'или страница могла быть удалена.',
  },
  REVIEW: {
    LEAVE_REVIEW: 'Оставить отзыв',
    HOW_RATE: 'Как бы вы оценили?',
    REVIEW_TEXT: 'Текст отзыва',
    RATE_US: 'Оцените нас',
    SUBMIT_REVIEW: 'Отправить отзыв',
    REVIEW_VERIFIED:
      'Все отзывы на Cool Co. Reviews проверяются в течение 48 часов перед публикацией, чтобы гарантировать их подлинность и точность.',
    OUR_REVIEWS: 'НАШИ ОТЗЫВЫ',
    YOUR_OPINION:
      'Ваше мнение важно для нас! Если вы хотите поделиться своими впечатлениями о наших продуктах или оставить отзыв, мы будем рады услышать вас. Это поможет нам стать лучше и радовать вас ещё больше. Спасибо, что выбрали нас!',
    WRITE_REVIEW: 'Написать отзыв',
    REPLAY_TO_REVIEW: 'Ответить на отзыв',
  },
  BASKET: {
    SPEACIAL_ITEM:
      'У вас в корзине есть особый товар. Необходимо завершить покупку, чтобы купить другие товары.',
  },
  COOKIE: {
    TITLE: 'Согласие на использование файлов cookie',
    ACCEPT:
      'Нажимая «Принять все cookie», вы соглашаетесь, что Stack Exchange может сохранять cookie на вашем устройстве и раскрывать информацию в соответствии с нашей',
    POLICY: 'Политикой использования файлов cookie',
  },
  CHAT_BOT: {
    TITLE: 'Чат-бот Tumar',
    SUBTITLE: 'Ответы на вопросы',
  },
  TRANSLATOR: {
    SELECT: 'Выберите язык',
  },
  MENU: {
    NEW: 'новое',
    ACTIONS: 'Действия',
    CREATE_POST: 'Создать новый пост',
    PAGES: 'Страницы',
    FEATURES: 'Функции',
    APPS: 'Приложения',
    DASHBOARD: 'Панель управления',
  },
  REYESTR_MENU: [
    {
      title: 'Messages',
      icon: '/img/icons/Group.svg',
      to: 'chat',
      disabled: false,
    },
    {
      title: 'Profile',
      icon: '/img/icons/Document.svg',
      to: 'profile',
      disabled: false,
    },
    {
      title: 'Invoice',
      icon: '/img/icons/Paper.svg',
      to: 'invoice orders',
      disabled: false,
    },
    {
      title: 'Special Order history',
      icon: '/img/icons/Folder.svg',
      disabled: false,
      to: 'special-order-history',
    },
    {
      title: 'Wholesale order',
      icon: '/img/icons/Folder.svg',
      disabled: false,
      to: 'order history',
      subLinks: [],
    },
    {
      title: 'Retail Order History',
      icon: '/img/icons/Folder.svg',
      disabled: false,
      to: 'retail order history',
      subLinks: [],
    },
    {
      title: 'PRICE LIST',
      icon: '/img/icons/Group.svg',
      to: 'price list',
      disabled: false,
    },
    {
      title: 'Product register',
      icon: '/img/icons/Group.svg',
      to: 'reyestr',
      disabled: false,
    },
  ],
  RETAIL_MENU: [
    {
      title: 'Messages',
      icon: '/img/icons/Group.svg',
      to: 'chat',
      disabled: false,
    },
    {
      title: 'Profile',
      icon: '/img/icons/Document.svg',
      to: 'profile',
      disabled: false,
    },
    {
      title: 'Special Order history',
      icon: '/img/icons/Folder.svg',
      disabled: false,
      to: 'special-order-history',
    },
    {
      title: 'Retail Order History',
      icon: '/img/icons/Folder.svg',
      disabled: false,
      to: 'retail order history',
      subLinks: [],
    },
  ],
  SEARCH: {
    SEARCH_KEYWORDS: 'Поиск по ключевым словам...',
    SEARCH: 'Поиск',
  },
  GROUPS: 'Группы',
  PRICE_TITLE: 'Цена',
  SELE_CTED_GROUP: 'Все',
  DROPDOWN: {
    items: ['Все', 'Мужское', 'Женское', 'Детское', 'Унисекс'],
  },
  FILTERS: {
    группы: {
      мужчина: false,
      женщина: false,
      ребенок: false,
      общий: false,
    },
    'production technique': {
      'solid-rolled': false,
      сшитый: false,
    },
    Модель: {
      тапочки: false,
      сапоги: false,
    },
  },
  FILTER_KEYS: {
    groups: 'groups',
    production_technique: 'тproduction technique',
    model: 'model',
  },
  AUTH: {
    GENERAL: {
      OR: 'Или',
      SUBMIT_BUTTON: 'Отправить',
      NO_ACCOUNT: 'Нет аккаунта?',
      SIGNUP_BUTTON: 'Зарегистрироваться',
      FORGOT_BUTTON: 'Забыли пароль',
      BACK_BUTTON: 'Назад',
      PRIVACY: 'Конфиденциальность',
      LEGAL: 'Юридическая информация',
      CONTACT: 'Контакты',
    },
    LOGIN: {
      TITLE: 'Вход в аккаунт',
      BUTTON: 'Войти',
    },
    FORGOT: {
      TITLE: 'Забыли пароль?',
      DESC: 'Введите свой e-mail для сброса пароля',
      SUCCESS: 'Ваш пароль успешно сброшен.',
    },
    REGISTER: {
      TITLE: 'Регистрация',
      DESC: 'Введите данные для создания аккаунта',
      SUCCESS: 'Ваш аккаунт успешно создан.',
    },
    LOGOUT: 'Выйти',
    INPUT: {
      EMAIL: 'E-mail',
      FULLNAME: 'Полное имя',
      PASSWORD: 'Пароль',
      CONFIRM_PASSWORD: 'Подтвердите пароль',
      USERNAME: 'Имя пользователя',
    },
    VALIDATION: {
      INVALID: '{{name}} недействителен',
      REQUIRED: '{{name}} обязателен',
      MIN_LENGTH: 'Минимальная длина для {{name}} — {{min}}',
      AGREEMENT_REQUIRED: 'Необходимо принять условия использования',
      NOT_FOUND: '{{name}} не найден',
      INVALID_LOGIN: 'Неверные данные для входа',
      REQUIRED_FIELD: 'Обязательное поле',
      MIN_LENGTH_FIELD: 'Минимальная длина:',
      MAX_LENGTH_FIELD: 'Максимальная длина:',
      INVALID_FIELD: 'Поле недействительно',
    },
  },
  ECOMMERCE: {
    COMMON: {
      SELECTED_RECORDS_COUNT: 'Количество выбранных записей: ',
      ALL: 'Все',
      SUSPENDED: 'Приостановлен',
      ACTIVE: 'Активен',
      FILTER: 'Фильтр',
      BY_STATUS: 'по статусу',
      BY_TYPE: 'по типу',
      BUSINESS: 'Бизнес',
      INDIVIDUAL: 'Частное лицо',
      SEARCH: 'Поиск',
      IN_ALL_FIELDS: 'по всем полям',
    },
    ECOMMERCE: 'Электронная торговля',
    CUSTOMERS: {
      CUSTOMERS: 'Клиенты',
      CUSTOMERS_LIST: 'Список клиентов',
      NEW_CUSTOMER: 'Новый клиент',
      DELETE_CUSTOMER_SIMPLE: {
        TITLE: 'Удаление клиента',
        DESCRIPTION:
          'Вы уверены, что хотите безвозвратно удалить этого клиента?',
        WAIT_DESCRIPTION: 'Клиент удаляется...',
        MESSAGE: 'Клиент удалён',
      },
      DELETE_CUSTOMER_MULTY: {
        TITLE: 'Удаление клиентов',
        DESCRIPTION:
          'Вы уверены, что хотите безвозвратно удалить выбранных клиентов?',
        WAIT_DESCRIPTION: 'Клиенты удаляются...',
        MESSAGE: 'Выбранные клиенты удалены',
      },
      UPDATE_STATUS: {
        TITLE: 'Статус выбранных клиентов обновлён',
        MESSAGE: 'Статус выбранных клиентов успешно обновлён',
      },
      EDIT: {
        UPDATE_MESSAGE: 'Клиент обновлён',
        ADD_MESSAGE: 'Клиент создан',
      },
    },
  },
  HEADER: {
    GO_TO_STORE: 'GO TO THE STORE',
    CON_TACTS: 'CONTACTS',
  },
  MAIN: {
    h1: 'Добро пожаловать',
    tumar: 'Tumar',
    logout: 'Выйти',
    info: {
      1: 'С панели своего аккаунта ты можешь посмотреть',
      2: 'недавние заказы',
      3: 'управлять своми',
      4: 'адресами доставки и выставлением счетов',
      5: 'и',
      6: 'редактировать пороль и информацию об аккаунте.',
    },
  },
  PROFILE: {
    balance: 'Your balance',
    order_details: 'Branding details',
    settings_title: 'Settings',
    user_title: 'User',
    edit_user: 'Edit user',
    user_form: [
      'First name',
      'Last name',
      'Disaply name',
      'Email address',
      'Role',
      'Password',
    ],
    change_password: 'Password change',
    password_change_form: [
      'Current password (leave blank to leave unchanged)',
      'New password (leave blank to leave unchanged)',
      'Confirm new password',
    ],
    save_password: 'Save changes',
    add: 'Add',
    delete: 'delete',
    edit: 'edit',
    user: ['User', 'E-mail adress', 'Role', 'Actions', ''],
  },
  INVOICE: {
    orders: {
      total_balance: 'Ваш баланс',
      table_header: [
        'Номер заказа',
        'Сумма заказа',
        'Инвойс',
        'Сумма инвойсов',
        'Статус заказа',
        'Cумма оплаты',
        'Баланс',
        '',
      ],
      view: 'Посмотреть',
    },
    invoices: {
      order_number: 'Order number',
      invoice_table: [
        'Номер инвойса',
        'Дата',
        'Статус',
        'Сумма ордера',
        'Сумма инвойса',
        'Actions',
      ],
      view: 'Посмотреть',
      statuses: {
        [PROCESSING_INVOICE_STATUS]: 'Обработка',
        [PAID_INVOICE_STATUS]: 'Оплачен',
      },
    },
  },
  BRENDING: {
    price: 'Price',
    choosePrice: 'Select a price',
    brending_text: 'Branding',
    pre_count: 'Number of selected items',
    colors: 'Choose a colour',
    add_to_cart: 'Add to basket',
    size: 'Choose a size',
    brending_body: {
      place: 'Leave logo',
      price_unchangable: 'The cost is unchanged',
      price_changable: '  The cost will vary depending on the logo',
      replace: 'Replace',
      delete: 'Delete',
    },
  },
  PRODUCT_DESCRIPTION: {
    branding: 'Branding',
    table: {
      image: 'picture',
      details: 'details',
      price: 'price',
      color: 'color',
      size: 'size',
      count: 'count',
      total: 'total',
      pre_count: 'precalculation',
      order_details: 'order details',
    },
    second_table: {
      totalCount: 'Total number',
      sum: 'amount',
      discount: 'discount',
      saving: 'saving',
      delivery: 'delivery',
      total: 'total',
      saved: 'saved',
    },
    go_to_order: 'proceed to checkout',
    notes:
      'Details of logo application on your goods will be provided later by the Manager on chat',
    logo_place: 'logo place',
    order_details: 'Order details',
  },
  REGISTRATION: {
    my_order: 'My order',
    payment_info: 'Payment information',
    first_name: 'Name',
    last_name: 'Surname',
    number: 'Telephone',
    email: 'Email ',
    delivery_adress: 'Enter the delivery address',
    country: 'Country',
    countries: ['Россия', 'Украина', 'Кыргызстан', 'Казахстан', 'Беларусь'],
    address: 'Address',
    home_number: 'House number and street name',
    locality: 'Settlement',
    region: 'Area/region',
    postcode: 'Postcode',
    inn: 'INN',
    your_order: 'Your order',
    coupon_code: 'IF YOU HAVE A COUPON CODE, PLEASE APPLY IT BELOW',
    coupon_placeholder: 'Got a promo code/discount card number?',
    apply_coupon: 'Confirm coupon',
    product: 'Merchandise',
    subtotal: 'Subtotal',
    shipping: 'carriages',
    total: 'Total',
    rule: 'By placing an order, you agree that TUMAR will store some of your data in order to improve the quality of the service.',
    place_order: 'place an order',
  },
  ORDER_HISTORY: {
    order: 'Ordering',
    ordered: 'Ordered',
    shipped: 'Posted',
    expected_delivery: 'Expected delivery',
    order_number: 'Order number',
    date: 'Date',
    total: 'Total',
    order_info: 'Order information',
    invoice: 'Invoice',
    retry: 'Repeat',
    payment_terminal: 'Payment terminal',
    delivery_address: 'Delivery address',
    order_table: ['Ordering', 'Date', 'Status', 'Total', 'Actions'],
    statuses: {
      [PROCESSING_ORDER_STATUS]: 'In processing',
      [PAYMENT_WAITING_ORDER_STATUS]: 'Pending payment',
      [IN_PRODUCTION_ORDER_STATUS]: 'In production',
      [ON_HOLD_ORDER_STATUS]: 'On hold',
      [COMPLETED_ORDER_STATUS]: 'Done',
      [PACKAGING_ORDER_STATUS]: 'Packaging of goods',
      [SHIPPING_ORDER_STATUS]: 'Dispatch of goods',
      [ON_WAY_ORDER_STATUS]: 'On the way',
    },
  },
  ORDER_COMPLEATE: {
    title: 'Go to order history',
    thanksTitle: 'Thank you. Your order has been accepted.',
  },
  PRICE_LIST: {
    price: 'Price list',
    main: 'Main',
  },
  CART_FOOTER: {
    view: 'View basket',
    ordering: 'Ordering',
    summary: 'Total',
    basket: 'Basket',
    close: 'close',
  },
  ORDER_DETAILS: {
    account: 'My account',
    order_details: 'Order details',
    title: 'ORDER DETAILS',
    table: ['Photo', 'Title', 'Residue', 'Actions'],
    order_details_table: [
      '№',
      'Date',
      'Product name',
      'Quantity of spent branding',
      'Current balance',
    ],
  },
}
